import React, { useMemo, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import useClickAway from '@hooks/useClickAway';
import { MediaQueries, BREAKPOINT_PHONE } from '@style/MediaQuery';

const BackgroundDim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 50%;
  padding: 10px;
  border-radius: 10px;
  width: ${({ width }) => width || '350px'};
  height: ${({ height }) => height || '500px'};
  transform: translate(-50%, -50%);
  background-color: white;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  ${MediaQueries(BREAKPOINT_PHONE)} {
    width: 100vw;
    height: 100vh;
    padding: 5px 26px;
    border-radius: 0;
  }
`;

const Modal = ({
  children,
  width,
  height,
  visible = false,
  onClose,
  style,
}) => {
  const handleClose = useClickAway((e) => {
    // onClose && onClose();
  });

  const topEl = useMemo(() => document.createElement('div'), []);

  useEffect(() => {
    document.body.appendChild(topEl);
    return () => {
      document.body.removeChild(topEl);
    };
  }, []);

  return ReactDOM.createPortal(
    <BackgroundDim style={{ display: visible ? 'block' : 'none' }}>
      <ModalContainer
        width={width}
        height={height}
        ref={handleClose}
        visible={visible}
        style={style}
      >
        {children}
      </ModalContainer>
    </BackgroundDim>,
    topEl,
  );
};

Modal.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Modal;
